import { render, staticRenderFns } from "./ReporteActas_Regalados.vue?vue&type=template&id=d79a742a"
import script from "./ReporteActas_Regalados.vue?vue&type=script&lang=js"
export * from "./ReporteActas_Regalados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports